import PropTypes from 'prop-types';
import React, { Component } from 'react';

import VideoPlayer from 'modules/Common/components/VideoPlayer';

export default class YouTubeVideo extends Component {
  static propTypes = {
    videoId: PropTypes.string,
    placeholderImage: PropTypes.string
  };

  constructor(...args) {
    super(...args);

    this.state = {
      showPlayer: true
    };

    this.playedOnce = false;
  }

  render() {
    const {videoId, placeholderImage} = this.props;

    const playerProps = {
      autoPlay: this.playedOnce,
      placeholderImage,
      onEnded: () => {
        this.setState({showPlayer: false});
      },
      errorMessage: ({code}) => {
        // These codes are from "videojs-youtube", but it doesn't export constants for them
        // hence the magic numbers. Comments show the associated "videojs-youtube" message
        switch (code) {
          case 1002:
          case 1100:
            // Unable to find the video
            return "this video is no longer available";
          case 1101:
          case 1150:
            // Playback on other Websites has been disabled by the video owner
            return "this video can no longer be played on our site";
        }
      }
    };

    if (this.state.showPlayer) {
      playerProps.src = {
        type: "video/youtube",
        src: `https://www.youtube.com/watch?v=${videoId}`
      };
    }
    else {
      playerProps.button = {
        type: "play",
        loadSrc: () => {
          this.setState({showPlayer: true});
          this.playedOnce = true;
        }
      };
    }

    return <VideoPlayer {...playerProps}/>;
  }
}


// WEBPACK FOOTER //
// ./modules/Common/components/YouTubeVideo.js